import { getDeviceType } from '~/utils/device'

/** Fires `alternative_flow_detected` when the user reaches the scan section with missing prerequisite steps. */
export const trackAlternativeFlowDetected = (content) => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
		missing_steps: content.missing_steps,
	}

	LuckyWiseAnalytics.click('alternative_flow_detected', params)
}

/** Fires `empty_state_displayed` when the scan empty state is shown. */
export const trackEmptyStateDisplayed = (content) => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
		missing_steps: content.missing_steps,
		current_tab: content.current_tab,
	}

	LuckyWiseAnalytics.click('empty_state_displayed', params)
}

/** Fires `step_guide_cta_click` when the user clicks an action inside the step-guide empty state. */
export const trackStepGuideCtaClick = (content) => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
		step_name: content.step_name,
	}

	LuckyWiseAnalytics.click('step_guide_cta_click', params)
}

/** Fires `alternative_flow_completed` when the user selects a lottery in the alternative (empty) flow. */
export const trackLotterySelected = (content) => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
		lottery_id: content.lottery_id,
	}

	LuckyWiseAnalytics.click('alternative_flow_completed', params)
}
